import FadeOut from './fade-out'
import FadeOutDown from './fade-out-down'
import FadeOutDownBig from './fade-out-down-big'
import FadeOutLeft from './fade-out-left'
import FadeOutLeftBig from './fade-out-left-big'
import FadeOutRight from './fade-out-right'
import FadeOutRightBig from './fade-out-right-big'
import FadeOutUp from './fade-out-up'
import FadeOutUpBig from './fade-out-up-big'

export default {
  FadeOut,
  FadeOutDown,
  FadeOutDownBig,
  FadeOutLeft,
  FadeOutLeftBig,
  FadeOutRight,
  FadeOutRightBig,
  FadeOutUp,
  FadeOutUpBig
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/fading-exits/index.js